import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

import { UIMessageReferenceProgress } from '../../../types/types';
import { DynamicStatusService } from '../dynamic-status/dynamic-status.service';

import { RefProgressComponent } from '../references/ref-progress/ref-progress.component';

/** Removes emoji and other symbols from status text for display. */
function stripEmoji(text: string): string {
  if (!text || typeof text !== 'string') return text;
  return text
    .replace(/[\u{1F300}-\u{1F9FF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}\u{1F600}-\u{1F64F}\u{1F680}-\u{1F6FF}\u{1F1E0}-\u{1F1FF}]/gu, '')
    .replace(/\s{2,}/g, ' ')
    .trim();
}

@Component({
  selector: 'app-status-center',
  templateUrl: './status-center.component.html',
  styleUrls: ['./status-center.component.scss'],
  standalone: true,
  imports: [RefProgressComponent],
})
export class StatusCenterComponent implements OnInit, OnDestroy {
  @Input() referenceProgress: UIMessageReferenceProgress | undefined;
  @Input() isWriting = false;

  protected dynamicStatus: string | null = null;
  private sub: Subscription | null = null;

  constructor(private dynamicStatusService: DynamicStatusService) {}

  ngOnInit(): void {
    this.sub = this.dynamicStatusService.statuses.subscribe((status) => {
      this.dynamicStatus = status ? stripEmoji(status) : null;
    });
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }

  protected get hasRefProgress(): boolean {
    if (!this.referenceProgress) return false;
    const s = this.referenceProgress.status;
    return s === 'initializing' || s === 'processing';
  }

  protected get hasContent(): boolean {
    return this.hasRefProgress || this.isWriting || !!this.dynamicStatus;
  }
}
